<ejs-sidebar id="sidebar-menu" #sidebarInstance type='Over' [width]='width' [position]='position'
             style="visibility: hidden" [enableGestures]="false" [showBackdrop]=true>

  <div class="offcanvas-close mt-n1 pr-5" style="float:right; padding: 48px;">
    <a href="javascript:;" class="btn btn-xs btn-icon btn-light btn-hover-primary" id="kt_quick_panel_close"
       (click)="closeSidebar()">
      <i class="ki ki-close icon-xs text-muted"></i>
    </a>
  </div>

  <div class='p-15'>
    <h2>Update Product for Article</h2>

    <form id="formId" [formGroup]="articleProductForm" #formDir="ngForm" class="form-horizontal" novalidate=""
          style="margin-top: 16px;">

      <div class="form-group sf-outline-input mb-10" [class.hide-label]="articleProductForm.controls.product_code.value == ''">
        <ejs-multiselect #contact id='product_code' formControlName="product_code" [dataSource]='productList'
                          [fields]='productFields' [showClearButton]=true (filtering)='onFiltering($event,"contact")'
                          placeholder='Product' [allowFiltering]='true' mode='CheckBox' showClearButton="true"
                          cssClass="e-filled" floatLabelType="Auto"
                          (blur)="articleProductForm.controls.product_code.markAsTouched()"></ejs-multiselect>
        <div *ngIf="articleProductForm.controls.product_code.errors">
          <div
            *ngIf="articleProductForm.controls.product_code.errors.required && articleProductForm.controls.product_code.touched"
            class="e-error">
            Product is required.
          </div>
        </div>
      </div>


      <div *ngIf="articleProductForm.invalid" class="e-error">Please fill all fields</div>
      <div *ngIf="error$ | async as error" class="e-error">{{error.error}}</div>

      <div class="my-10 pb-20">
        <button id="resetbtn"
                class="btn btn-outline-secondary text-uppercase font-weight-bold px-15 py-5 float-right btn-block mb-5"
                type="button"
                data-ripple="true" (click)="clear()">Clear
        </button>
        <button  id="addSubmit"
                class="btn btn-primary text-uppercase font-weight-bold px-15 py-5 float-right btn-block" type="submit"
                (click)="onAddArticleProductLink(articleProductForm)" [disabled]="formSent" data-ripple="true"> Update
          Product for Article
        </button>
      </div>
    </form>
  </div>
</ejs-sidebar>

<ejs-dialog #clearModal [buttons]='dltButtons' header='Are you sure?' animationSettings='none' showCloseIcon='true'
            width='25%' [visible]='false'>
  <ng-template #content>
    <p>This action will clear all form fields.</p>
  </ng-template>
</ejs-dialog>
